document.addEventListener("DOMContentLoaded", function () {
  // Create an observer to watch for bundle & save button to show up
  const parentElement = document.querySelector("form.product-single__form");

  if (!parentElement) return; // Ensure the parent element exists

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      const addedNodes = Array.from(mutation.addedNodes) || [];
      const bundlenSaveBtn = addedNodes.find((node) => 
        node.nodeType === 1 && node.getAttribute("data-widget-slug") === "bndnsve"
      );

      if (bundlenSaveBtn) {
        bundlenSaveBtn.addEventListener("click", function () {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: "ga4_select_promotion",
            ga4_data: {
              creative_name: "CTA click",
              promotion_name: "Bundle & Save",
            },
          });
        });
      }
    });
  });

  const config = { childList: true, subtree: true };
  observer.observe(parentElement, config);
});
